import { Box } from '@material-ui/core';
import { SelectItemOverlay } from 'component/layout_quiz/select_item_overlay';
import { useEffect, useRef } from 'react';
import { useStyles } from './styles';

export const HairColorItem = ({ item, index, handleSelectItem }) => {
    let itemRef: any = useRef();
    const classes = useStyles();

    useEffect(() => {
        if (itemRef && item.isSelect) {
            (itemRef as any).scrollIntoView({ behavior: 'auto', block: 'center', inline: 'center' });
        }
    }, [itemRef, item.isSelect]);

    return (
        <div
            ref={(ref) => {
                itemRef = ref;
            }}
        >
            <Box
                borderRadius={8}
                overflow={'hidden'}
                display={'flex'}
                flexDirection={'column'}
                onClick={() => handleSelectItem(item)}
                style={{
                    padding: 8,
                    background: item.isSelect ? '#1A1A1A' : 'transparent',
                    transition: 'background 0.3s',
                }}
            >
                <Box className={classes.colorItem} overflow={'hidden'}>
                    <img style={{ width: '100px', borderRadius: 8 }} src={item.imageUrl} alt={item.title} />
                    {item.isSelect && <SelectItemOverlay />}
                </Box>

                <p className={classes.itemTitle} style={{ color: item.isSelect ? '#F2F2F2' : '#1A1A1A' }}>
                    {item.title}
                </p>
            </Box>
        </div>
    );
};
